import {
  createPersonalApiKeyMutation,
  type CreatePersonalApiKeyMutationVariables,
  personalApiKeysQuery,
  revokePersonalApiKeyMutation,
  rotatePersonalApiKeyMutation,
} from '@affine/graphql';
import { Store } from '@toeverything/infra';

import type { GraphQLService } from '../services/graphql';

export class PersonalApiKeyStore extends Store {
  constructor(private readonly gql: GraphQLService) {
    super();
  }

  async list() {
    return (await this.gql.gql({ query: personalApiKeysQuery }))
      .personalApiKeys;
  }

  async create(variables: CreatePersonalApiKeyMutationVariables) {
    return (
      await this.gql.gql({ query: createPersonalApiKeyMutation, variables })
    ).createPersonalApiKey;
  }

  async rotate(id: string, expirationDays: number | null) {
    return (
      await this.gql.gql({
        query: rotatePersonalApiKeyMutation,
        variables: { id, expirationDays },
      })
    ).rotatePersonalApiKey;
  }

  async revoke(id: string) {
    await this.gql.gql({
      query: revokePersonalApiKeyMutation,
      variables: { id },
    });
  }
}
